import React from 'react';
import { BiHome, BiBookAlt, BiMessage, BiGroup, BiLogOut } from 'react-icons/bi';
import { BsTicketDetailed } from 'react-icons/bs';
import { CgProfile } from 'react-icons/cg';
import { FaChartBar } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks.ts';
import { logout } from '../../features/authSlice.ts';
import { toast } from 'react-toastify';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = () => {
    dispatch(logout());
    toast.success("User Logout Successful");
    navigate("/auth");
  };

  return (
    <div className="menu">
      <div className="logo">
        <BiBookAlt className="logo-icon" />
        <h2>Admin</h2>
      </div>

      <div className="menu--list">
        <Link to="/dashboard" className={`item ${isActive('/dashboard') ? 'active' : ''}`}>
          <BiHome className="icon" />
          <span>Dashboard</span>
        </Link>

        <Link to="/tickets" className={`item ${isActive('/tickets') ? 'active' : ''}`}>
          <BsTicketDetailed className="icon" />
          <span>Tickets</span>
        </Link>

        <a href="#" className="item">
          <BiGroup className="icon" />
          <span>Agents</span>
        </a>

        <Link to="/tickettrafficmanagement" className={`item ${isActive('/tickettrafficmanagement') ? 'active' : ''}`}>
          <FaChartBar className="icon" />
          <span>Charts</span>
        </Link>

        <a href="#" className="item">
          <BiMessage className="icon" />
          <span>Messages</span>
        </a>

        <a href="#" className="item">
          <CgProfile className="icon" />
          <span>Profile</span>
        </a>
      </div>

      <div className="menu--logout">
        <button 
          type="button" 
          className="item logout-btn" 
          onClick={handleLogout}
        >
          <BiLogOut className="icon" />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;